import React from 'react';
/*
import {
  hf,
  ht,
  f,
  cr,
  useGblz,
  a,
  ls,
  BoxC,
  IptC,
  LblC,
  LgnIdC,
  MsgC,
  RootC,
  GridC,
  TextC,
  _cv_10___Mz,
  _cv_31___Mz,
  _cv_40___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as MsgC from "./_cccMsgC";
import * as LgnIdC from "./_ccmLgnIdC";
import * as RootC from "./_ccmRootC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';
import IccvFtr from './IccvFtr';

let $_10rs = [] as ht.ls;
let $idz = {
  id: '',
  pwd: '',
};

export const N = (pz: {
}) => {

  const _gUserz = gs.useGblz('user');

  const _frcUdt = ls.frcUdt();

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
    frcUdt: _frcUdt,
    atrAsync: async () => {
      await _cv_10___Mz.load_10rLsAsync({
        _31r_fst: _gUserz.crt._31rz?._fst,
        _10rt1100i: 20,
        cdn: 'true',
      })
      .then((_ls: ht.ls) => {
        $_10rs = _ls;
      })
    }
  })

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        oClds: [

          cr.c(GridC.N, {
            key: -20,
            abtType: 'lgnCmnz',
            lineCs: [
              {
                cellCs: [
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgStfz',
                        textz: {
                          pfx: `【${_gUserz.crt._20rz?._pfx}】 施設予約管理【スタッフ用】`,
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [

                      cr.c(MsgC.N, {
                        key: -10,
                        abtType: 'lgn1Cmnz',
                        cz: {
                          ls: [
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '▼',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '登録したログインIDとパスワードを入力し、[ログイン] ボタンを押してください。',
                                },
                              }
                            },
                          ]
                        }
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/3'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(LgnIdC.N, {
                        key: -20,
                        cz: {
                          idz: $idz,
                          ccd: 'gn7',
                          _10rs: $_10rs,
                          grtCfmz: () => ({
                            cdn: `_10r_31r1f IN (${_gUserz.crt._31rz._fst}) AND _10rt1100i = 20` 
                          }),
                          atrCfm: async (_dz: ht.dz) => {
                            const _31z = await _cv_31___Mz.load_31rDzAsync({
                              _31r_fst: _gUserz.crt._31rz._fst
                            });
                            await _gUserz.saveAsync({
                              _31rz: _31z._31rz,
                            });
                            const _40rz = await _cv_40___Mz.load_40rAzAsync({
                              _31r_fst: _gUserz.crt._31rz._fst,
                              _10r_key: _gUserz.crt._10rz._key,
                            })
                            await _gUserz.saveAsync({
                              _40rz: _40rz,
                            });
                            await _gUserz.saveAsync({
                              usrClr: 'gn',
                            });
                            cr.moveTo({
                              pageName: 'icvHomeS10Rz',
                            })
                          },
                        }
                      })

                    ]
                  }
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [

                      cr.c(BoxC.N, {
                        key: -10,
                        boxStlz: a('f/1'),
                        oClds: [
                          cr.c(TextC.N, {
                            key: -10,
                            textz: {
                              pfx: '※ パスワードが不明な場合は、システム管理者までお問い合わせください。',
                              stlz: a('ts/s'),
                            },
                          }),
                        ]
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/2'),
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(IccvFtr, {
            key: -30,
          })

        ],
      },
    })
  );
};
